import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

import styles from './css/AlertDialog.module.css';
import partyStyles from './domestic/EditPartyDialog.module.css';

const EDIT_PARTY_CLOSE_ICON = (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
    <path
      d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z"
      fill="#5B5B5B"
    />
  </svg>
);

const GRID_FEEDBACK_MESSAGE_KEYS = [
  'trackAutos.gridReset',
  'trackAutos.gridSaved',
  'domesticViewBooking.gridReset',
  'domesticViewBooking.gridSaved',
  'domesticManageMyTemplates.gridReset',
  'domesticManageMyTemplates.gridSaved',
  'domesticBookingUpdate.gridReset',
  'domesticBookingUpdate.gridSaved',
];

const GRID_FEEDBACK_LITERAL_MESSAGES = new Set([
  'Grid settings reset.',
  'Grid settings saved.',
  'Grid preferences saved.',
]);

const isGridSettingsFeedbackPopup = (props) => {
  const isSuccessTitle =
    props.title === 'Success' ||
    props.title === props.t('alertDialog.success');

  if (!isSuccessTitle) return false;

  if (GRID_FEEDBACK_LITERAL_MESSAGES.has(props.msg)) return true;

  return GRID_FEEDBACK_MESSAGE_KEYS.some((key) => props.t(key) === props.msg);
};

const getTitle = (props) => {
  if (props.title === 'Success') return props.t('alertDialog.success');
  else if (props.title === 'Confirm') return props.t('alertDialog.confirm');
  else if (props.title === 'Info') return 'Info';
  else return props.t('alertDialog.error');
};

const AlertDialog = (props) => {
  const isNonErrorTitle =
    props.title === 'Success' ||
    props.title === 'Confirm' ||
    props.title === 'Info';
  const isOhanaError = props.variant === 'ohana' && !isNonErrorTitle;
  const isDomesticLegacyError = props.variant === 'domestic' && !isNonErrorTitle;
  const isGridSettingsPopup = isGridSettingsFeedbackPopup(props);
  const isOhanaLayout = isOhanaError || isGridSettingsPopup;
  const useEditPartyClose =
    isOhanaError || isDomesticLegacyError || isGridSettingsPopup;

  return (
    <Modal
      id="alertModal"
      show={props.show}
      centered
      className={[
        styles.modalContainer,
        isOhanaLayout ? styles.ohanaModal : '',
      ].join(' ')}
      onHide={() => {}}
    >
      <div
        className={[
          styles.alertCard,
          isOhanaLayout ? styles.ohanaCard : '',
          isGridSettingsPopup ? styles.ohanaGridSavedSuccess : '',
          isOhanaError && props.showTimestamp ? styles.ohanaShowTimestamp : '',
          isOhanaError && props.legacyOkButton ? styles.ohanaLegacyOkButton : '',
        ]
          .filter(Boolean)
          .join(' ')}
      >
        <div className={styles.btnCloseDiv}>
          {useEditPartyClose ? (
            <button
              type="button"
              aria-label="Close dialog"
              className={partyStyles.dialogCloseBtn}
              onClick={props.didClose}
            >
              {EDIT_PARTY_CLOSE_ICON}
            </button>
          ) : (
            <i
              className={[styles.closeIcon, 'fa fa-times-circle-o'].join(' ')}
              onClick={props.didClose}
            />
          )}
        </div>
        <div className={styles.imgIconDiv}>
          <img
            className={styles.imgIcon}
            src={
              props.title === 'Success'
                ? require('./../assets/images/TickIcon.png').default
                : props.title === 'Confirm'
                ? require('./../assets/images/QuestionIcon.png').default
                : props.title === 'Info'
                ? require('./../assets/images/info.png').default
                : require('./../assets/images/errorIcon.png').default
            }
            alt="icon"
          />
        </div>
        <div className={styles.txtTitleDiv}>
          <span className={styles.txtTitle}>{getTitle(props)}</span>
        </div>
        <div className={styles.txtMsgDiv}>
          <span className={styles.txtMsg}>{props.msg}</span>
        </div>
        <div className={styles.btnButtonDiv}>
          {props.buttons ? (
            props.buttons.map((obj, index) => (
              <Button
                key={index}
                block
                className={styles.btnButton}
                onClick={obj.onPress}
              >
                {obj.title}
              </Button>
            ))
          ) : (
            <Button block className={styles.btnButton} onClick={props.didClose}>
              {props.t('alertDialog.btnOK')}
            </Button>
          )}
        </div>
        <div className="text-muted">Timestamp : {new Date().toUTCString()}</div>
      </div>
    </Modal>
  );
};

export default withTranslation('common')(AlertDialog);
